import { render } from "./SecurityFill.vue?vue&type=template&id=112848a6"
const script = {}

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__